import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { el } from "../lib/dom";
import { sectionCover } from "../lib/sectionCover";
import { story } from "../content/site";
import { photos } from "../content/photos.generated";

export function renderStory(root: HTMLElement) {
  const page = el("section", { class: "page", id: "ons-verhaal" });

  page.appendChild(
    sectionCover({
      title: "Ons Verhaal",
      photo: photos.story[0] ?? photos.gallery[0] ?? null,
    }),
  );

  const content = el("div", { class: "page__content" });

  const timeline = el("div", { class: "timeline" });
  story.forEach((item) => {
    const node = el(
      "article",
      { class: "timeline__item" },
      el("p", { class: "timeline__year" }, item.year),
      el("p", { class: "timeline__text" }, item.text),
    );
    timeline.appendChild(node);
  });
  content.appendChild(timeline);
  page.appendChild(content);
  root.appendChild(page);

  for (const item of timeline.querySelectorAll(".timeline__item")) {
    gsap.from(item, {
      opacity: 0,
      y: 32,
      duration: 0.9,
      ease: "power3.out",
      scrollTrigger: { trigger: item, start: "top 85%" },
    });
  }
  ScrollTrigger.refresh();
}
